export enum NotificationMode {
  Digest = 'Digest',
  Instant = 'Instant',
  None = 'None',
}

export interface Preference {
  mode: NotificationMode;
  myCS: boolean;
  tags: string[];
}
